/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  onSnapshot,
  writeBatch,
  doc,
  getDocs,
  orderBy,
} from "firebase/firestore";
import { db } from "@/lib/firebase";

export const useNotifications = (userId: string) => {
  const [notifications, setNotifications] = useState<any[]>([]);

  useEffect(() => {
    if (!userId) return;

    const loadNotifications = async () => {
      try {
        const response = await fetch(
          "https://firestore.googleapis.com/v1/projects/packtivate-a03a7/databases/(default)/documents/user_notifications",
        );

        const data = await response.json();

        const notifications =
          data.documents
            ?.filter((doc: any) => doc.fields.user_id?.stringValue === userId)
            .map((doc: any) => ({
              id: doc.name.split("/").pop(),
              title: doc.fields.title?.stringValue,
              message: doc.fields.message?.stringValue,
              is_read: doc.fields.is_read?.booleanValue,
            })) || [];

        // console.log(notifications);

        setNotifications(notifications);
      } catch (err) {
        console.error(err);
      }
    };

    loadNotifications();
  }, [userId]);

  return { notifications };
};

export const markAllNotificationsAsRead = async (notifications: any[]) => {
  try {
    const batch = writeBatch(db);
    notifications.forEach((n) => {
      if (!n.is_read) {
        const ref = doc(db, "user_notifications", n.id);
        batch.update(ref, { is_read: true });
      }
    });
    await batch.commit();
  } catch (err) {
    console.error("Error marking all as read:", err);
  }
};
